module.exports = __webpack_public_path__ + "img/expir.b2d2fc3d.svg";